<template>
  <div>
    <div v-for="(neutral, index) in dataList" :key="index">
      <template v-if="neutral.content.ReplyType == 1">
        <ResponseType1
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          class="mx-3"
        />
      </template>
      <template v-if="neutral.content.ReplyType == 2">
        <ResponseType2
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          :flowActiveIds="flowActiveIds"
          :level="level"
          v-on:updateIntent="updateIntent"
          v-on:openDeleteButtonModal="openDeleteButtonModal"
          v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
          v-on:openNextFlowListFromButton="openNextFlowListFromButton"
          class="mx-3"
        />
      </template>
      <template v-if="neutral.content.ReplyType == 3">
        <ResponseType3
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          :flowActiveIds="flowActiveIds"
          :level="level"
          class="mx-3"
        />
      </template>
      <template v-if="neutral.content.ReplyType == 4">
        <ResponseType4
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          class="mx-3"
        />
      </template>
      <template v-if="neutral.content.ReplyType == 5">
        <ResponseType5
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          :flowActiveIds="flowActiveIds"
          :level="level"
          v-on:openDeleteButtonModal="openDeleteButtonModal"
          v-on:updateIntent="updateIntent"
          v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
          v-on:openNextFlowListFromButton="openNextFlowListFromButton"
          class="mx-3 mb-2"
        />
      </template>
      <template v-if="neutral.content.ReplyType == 10">
        <ResponseType6
          :data="neutral"
          :channelList="channelList"
          :dataLength="dataList.length"
          class="mx-3"
        />
      </template>
    </div>

    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import ResponseType1 from "@/views/pages/flow-builder/components/response-type/ResponseType1";
import ResponseType2 from "@/views/pages/flow-builder/components/response-type/ResponseType2";
import ResponseType3 from "@/views/pages/flow-builder/components/response-type/ResponseType3";
import ResponseType4 from "@/views/pages/flow-builder/components/response-type/ResponseType4";
import ResponseType5 from "@/views/pages/flow-builder/components/response-type/ResponseType5";
import ResponseType6 from "@/views/pages/flow-builder/components/response-type/ResponseType6";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
export default {
  components: {
    ResponseType1,
    ResponseType2,
    ResponseType3,
    ResponseType4,
    ResponseType5,
    ResponseType6,
    ModalAlert,
    ModalLoading,
    ModalAlertError,
    ModalAlertConfirm,
  },
  props: {
    dataList: {
      required: true,
      type: Array,
    },
    channelList: {
      required: true,
      type: Array,
    },

    flowActiveIds: {
      required: true,
      type: Array,
    },
    level: {
      required: true,
      type: Number,
    },
    mainIntent: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      modalMessage: "",
      requestDeleteButton: {
        buttonId: 0,
      },
    };
  },
  methods: {
    updateIntent() {
      this.$emit("updateIntent");
    },
    openNextFlowListFromButton(level, id) {
      this.$emit("openNextFlowListFromButton", level, id);
    },
    setShowAllKeyword() {
      this.$emit("setShowAllKeyword");
    },
    createOrUpdateChildIntent(item) {
      this.$emit("createOrUpdateChildIntent", item, this.mainIntent);
    },
    openDeleteButtonModal(button) {
      this.requestDeleteButton.buttonId = button.Id;
      this.modalMessage = "คุณต้องการลบ " + button.Data + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      this.$refs.modalLoading.show();
      await this.axios
        .delete(
          `${this.$baseUrl}/flowBuilder/deleteButton/${this.requestDeleteButton.buttonId}`
        )
        .then((data) => {
          this.modalMessage = data.message;
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.$refs.modalAlert.show();
          } else {
            this.$refs.modalAlertError.show();
          }
        });
    },
    hadleModalAlertClose() {
      this.$emit("onReloadFlowList");
    },
  },
};
</script>

<style lang="scss" scoped></style>
